import React from "react";
import { Row, Col } from "reactstrap";
import bgImage from "assets/img/restaurant.jpg";
import menusImage from "assets/img/menus2.png";
import ordersImage from "assets/img/ordersImage.png";
import dashboardImage from "assets/img/dashboardSection.png";
import restaurantsImage from "assets/img/restaurantsSection.png";
import cartImage from "assets/img/cartImage.png";
import trackingImage from "assets/img/trackingImage.png";
import driverApp1 from "assets/img/driverApp1.png";
import driverApp2 from "assets/img/driverApp2.png";
import driverApp3 from "assets/img/driverApp3.png";
import customerApp1 from "assets/img/customerApp1.png";
import customerApp2 from "assets/img/customerApp2.png";
import customerApp3 from "assets/img/customerApp3.png";
import adminApp1 from "assets/img/Admin1.jpg";
import adminApp2 from "assets/img/Admin2.jpg";
import adminApp3 from "assets/img/Admin3.jpg";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faCheckCircle,
  faMapMarkedAlt,
  faClock,
  faComments,
  faMoneyBillWave,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
const Services = () => {
  return (
    <>
      <div
        className="text-center text-white py-5 px-3 m-4 mt-8 rounded overflow-hidden position-relative"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay-dark"></div>

        <div className="position-relative z-1">
          <Row className="justify-content-center">
            <Col xs={12} md={10} lg={8}>
              <h1 className="mb-3 fw-bold text-white">Our Services</h1>
              <p className="mx-auto" style={{ maxWidth: "600px" }}>
                Order food from your favorite restaurants with ease. Explore
                menus, place orders, and enjoy quick delivery — all available on
                our website and mobile app.
              </p>
            </Col>
          </Row>
        </div>
      </div>
      <Row className="align-items-center justify-content-center bg-white py-5">
        <Col lg="5" md="10" className="px-5 px-md-4">
          <h2 className="text-pink">Customer's Mobile App!</h2>
          <p className="text-dark">
            With our easy-to-use mobile app, finding and ordering food has never
            been simpler. Browse your favorite restaurants, check their menus,
            see ratings, and explore availability — all from your phone.
          </p>
          <p className="text-dark">
            Whether you're in the mood to dine-in, take away, or get food
            delivered, our app gives you the flexibility to order your way,
            anytime, anywhere. From quick snacks to full meals, everything you
            crave is just a few taps away — fast, convenient, and delicious.
          </p>
        </Col>

        <Col
          lg="5"
          md="10"
          className="text-center px-4 d-flex align-items-center justify-content-center"
          style={{ height: "350px" }}
        >
          <div className="position-relative phone-wrapper">
            <img src={customerApp2} className="leftPhone" alt="phone" />
            <img src={customerApp1} className="centerPhone" alt="phone" />
            <img src={customerApp3} className="rightPhone" alt="phone" />
          </div>
        </Col>
      </Row>
      <Row className="align-items-start justify-content-center bg-pink py-5">
        <Col
          lg="5"
          md="10"
          className="px-5 px-md-4 d-flex align-items-center justify-content-center mb-4 mb-lg-0"
        >
          <div className="d-flex flex-column w-100 h-100">
            <div className="w-100 text-start d-block d-lg-none mb-2 mb-lg-0">
              <h2 className="text-secondary">Customer's Web App!</h2>
            </div>
            <div className="mb-3">
              <img
                src={restaurantsImage}
                alt="Restaurants"
                className="rounded shadow-lg w-100"
              />
            </div>

            <div className="d-flex justify-content-between">
              <img
                src={cartImage}
                alt="Cart"
                className="img-fluid rounded shadow-sm"
                style={{ width: "48%", height: "150px", objectFit: "fill" }}
              />
              <img
                src={trackingImage}
                alt="Tracking"
                className="img-fluid rounded shadow-sm"
                style={{ width: "48%", height: "150px", objectFit: "fill" }}
              />
            </div>
          </div>
        </Col>

        <Col
          lg="5"
          md="10"
          className="px-5 px-md-4 d-flex flex-column justify-content-center"
        >
          <h2 className="text-white d-none d-lg-block">Customer's Web App!</h2>
          <p className="text-white">
            Browse your favorite restaurants, check their details, availability,
            and explore their menus — all in one place. Whether you want to
            dine-in, take away, or get food delivered at your doorstep, our
            platform and mobile app make it quick, simple, and convenient to
            satisfy your cravings.
          </p>
          <p className="text-white">
            Our system isn’t just for customers — restaurant owners also get a
            powerful, easy-to-use dashboard, available on both web and mobile.
            Manage menus, orders, staff, drivers, revenue, and customer feedback
            — whether you run a single outlet or multiple branches, everything
            stays organized and accessible anytime, anywhere.
          </p>
        </Col>
      </Row>

      <Row className="align-items-center justify-content-center bg-white py-5">
        <Col lg="5" md="10" className="px-5 px-md-4">
          <h2 className="text-pink">Restaurant Management Mobile App!</h2>
          <p className="text-dark">
            {" "}
            Admins can easily create menus with categories and items, visible to
            restaurants for quick updates and management. Track every customer
            order in real-time with statuses like Pending, Processing, Ready,
            and Completed. Generate detailed sales and revenue reports to stay
            on top of business growth.
          </p>
          <p className="text-dark">
            {" "}
            This all-in-one platform lets you manage staff, drivers, customers,
            tables, offers, and requests, all from your phone. You can also
            collect customer feedback, adjust settings, and monitor
            subscriptions — making restaurant operations smooth and
            mobile-friendly.
          </p>
        </Col>

        <Col
          lg="5"
          md="10"
          className="text-center px-5 px-md-4 d-flex align-items-center justify-content-center"
          style={{ height: "350px" }}
        >
          <div className="position-relative phone-wrapper">
            <img src={adminApp2} className="leftPhone" alt="phone" />

            <img src={adminApp3} className="centerPhone" alt="phone" />

            <img src={adminApp1} className="rightPhone" alt="phone" />
          </div>
        </Col>
      </Row>
      <Row className="align-items-start justify-content-center bg-pink py-5">
        <Col
          lg="5"
          md="10"
          className="px-5 px-md-4 d-flex align-items-center justify-content-center mb-4 mb-lg-0"
        >
          <div className="d-flex flex-column w-100 h-100">
             <div className="w-100 text-start d-block d-lg-none mb-2 mb-lg-0">
              <h2 className="text-secondary">Restaurant Management Web App!</h2>
            </div>
            <div className="mb-3">
              <img
                src={menusImage}
                alt="Menus"
                className="img-fluid rounded shadow-sm w-100"
                style={{ height: "200px" }}
              />
            </div>
            <div className="d-flex justify-content-between">
              <img
                src={ordersImage}
                alt="Orders"
                className="img-fluid rounded shadow-sm"
                style={{ width: "48%", height: "150px", objectFit: "fill" }}
              />
              <img
                src={dashboardImage}
                alt="Dashboard"
                className="img-fluid rounded shadow-sm"
                style={{ width: "48%", height: "150px", objectFit: "fill" }}
              />
            </div>
          </div>
        </Col>
        <Col
          lg="5"
          md="10"
          className="px-5 px-md-4 d-flex flex-column justify-content-center"
        >
          <h2 className="d-none d-lg-block text-secondary">
               Restaurant Management Web App!
          </h2>
          <p className="text-secondary">
            Admins can create Menus with Categories and Items. These are visible
            to restaurants, allowing them to manage food offerings easily. Track
            all customer orders with real-time status updates like Pending,
            Processing, Ready, and Completed. View detailed revenue reports
            based on sold items and orders to monitor business growth.
          </p>
          <p className="text-secondary">
            This all-in-one restaurant management platform lets you handle
            everything — from creating Menus, managing Staff, Drivers, and
            Customers to tracking Orders, Offers, and Requests. You can also
            manage Tables, view Customer Feedback, customize settings, and
            monitor Subscriptions — all in one place, making restaurant
            operations simple and organized.
          </p>
        </Col>
      </Row>
      <Row className="align-items-center justify-content-center bg-white py-5">
        <Col lg="5" md="10" className="px-5 px-md-4">
          <h2 className="text-pink">Driver App</h2>
          <ul
            className="list-unstyled"
            style={{ fontSize: "1.1rem", lineHeight: "2" }}
          >
            <li>
              <FontAwesomeIcon icon={faBox} className="text-primary mr-2" />
              View all <strong>processed orders</strong> ready for delivery.
            </li>
            <li>
              {" "}
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="text-success mr-2"
              />
              Accept delivery tasks with a single tap.
            </li>
            <li>
              <FontAwesomeIcon
                icon={faMapMarkedAlt}
                className="text-info mr-2"
              />
              Get <strong>optimized routes</strong> to the customer location.
            </li>
            <li>
              {" "}
              <FontAwesomeIcon icon={faClock} className="text-warning mr-2" />
              Track delivery status in real-time.
            </li>
            <li>
              {" "}
              <FontAwesomeIcon
                icon={faComments}
                className="text-secondary mr-2"
              />
              Easy communication with restaurant & customer.
            </li>
            <li>
              <FontAwesomeIcon
                icon={faMoneyBillWave}
                className="text-success mr-2"
              />
              Keep track of your{" "}
              <strong>completed deliveries and earnings.</strong>
            </li>
            <li className="mb-3">
              <FontAwesomeIcon icon={faMobileAlt} className="text-dark mr-2" />
              Fully available on <strong>mobile app</strong>, stay connected
              anytime, anywhere.
            </li>
          </ul>
        </Col>
        <Col
          lg="5"
          md="10"
          className="text-center px-5 px-md-4 d-flex align-items-center justify-content-center"
          style={{ height: "350px" }}
        >
          <div className="position-relative phone-wrapper">
            <img src={driverApp1} className="leftPhone" alt="Driver App" />

            <img src={driverApp2} className="centerPhone" alt="Driver App" />

            <img src={driverApp3} className="rightPhone" alt="Driver App" />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Services;
